import { Flex, Typography } from '@aloft/toolkit-sui';

import { useMemo } from 'react';

import { selectDepreciationByCategory } from '../../../../redux/features/selectors/selectDepreciationByCategory.ts';
import { selectOrderFeatures } from '../../../../redux/features/selectors/selectOrderFeatures.ts';
import { useAppSelector } from '../../../../redux/hooks.ts';
import { RootState } from '../../../../redux/types.ts';
import { FEATURE_DISPLAY_TEXTS } from './constants.ts';

export const TotalSeparateDepreciationCalculationTooltipText = ({
  activeId,
}: {
  activeId: string;
}) => {
  const features = useAppSelector(selectOrderFeatures);
  const depreciations = useAppSelector((state: RootState) =>
    selectDepreciationByCategory(state, activeId),
  );

  const featureString = useMemo(
    () =>
      ['mainDwelling', ...features]
        .map((feature) => {
          const depreciation = depreciations[feature];

          if (!depreciation) return '';
          if (depreciation.toNumericPrice() === 0) return '';

          return `${FEATURE_DISPLAY_TEXTS[feature] ?? feature} -${depreciation.toString(true)}`;
        })
        .filter((featureLine) => featureLine !== ''),
    [depreciations, features],
  );

  return (
    <Flex flexDirection="column">
      <Typography variant="body1" color="textOffset">
        Depreciation by Structure
      </Typography>
      <Flex height="1rem" />
      {featureString.map((str) => (
        <Typography key={str} variant="body1" color="textOffset">
          {str}
        </Typography>
      ))}
    </Flex>
  );
};
